import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ExpenseLimitPolicyService from "../../services/ExpenseLimitPolicyService";
import ExpenseService from "../../services/ExpenseService";

const initialState = {
  expenseLimits: {},
  status: 'idle'
};

export const fetchExpenseLimits = createAsyncThunk('expenseLimitList', async () => {
  const response = await ExpenseLimitPolicyService.fetchExpensePolicyList();
  return response;
});

export const ExpenseLimit = createSlice({
  name: "expenseLimit",
  initialState,
  reducers:{},
  extraReducers:(builder) => {
    builder
    .addCase(fetchExpenseLimits.pending, (state) => {
      state.status = "loading";
    })
    .addCase(fetchExpenseLimits.fulfilled, (state, action) => {
      state.status = "idle";
      state.expenseLimits = action.payload;
    });
  }
});

export const selectExpenseLimits = (state) => {
  return state.expenseLimit.expenseLimits;
} 

export default ExpenseLimit.reducer;